export const getPriceChangeClass = (changePercent) => {
    return changePercent > 0 ? 'plus' : 'minus';
};